module.exports = __webpack_public_path__ + "files/b27eb5e4f8f64ff29f7ac8f7952fc79f.png";